import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase';
import ChatRoomsList from '../ChatRoomsList/ChatRoomsList';
import SignOut from '../SignOut/SignOut';
import './Profile.css';

const Profile = () => {
    const [user] = useAuthState(auth);
    const {photoURL, displayName, email} = user;
    return (
        <div className="profile">
            {user && (
                <div className="user-info">
                    <img
                        src={photoURL ? photoURL : "https://www.w3schools.com/w3images/avatar2.png"}
                        alt="avatar"
                        className="avatar"
                    />
                    <h1>{displayName.toUpperCase()}</h1>
                    <p>{email}</p>
                    <SignOut />
                </div>
            )}
            <ChatRoomsList />
        </div>
    );
};

export default Profile;